const SEARCH_TOKENIZER = /[\s-_]+/

export const search = <T extends { [key: string]: any }>(
  items: T[],
  index: string | string[],
  query: string,
): T[] => {
  if (!query) {
    return items
  }

  const idxs = typeof index === 'string' ? [index] : index
  const tokens = query
    .toLowerCase()
    .split(SEARCH_TOKENIZER)
    .filter((t) => t.length > 0)

  return items.filter((item) => {
    const doc = idxs
      .map((idx) => item[idx])
      .join('')
      .toLowerCase()

    return tokens.every((token) => doc.includes(token))
  })
}
